module.exports = "<h1>Test Connection</h1>\r\n\r\n<button id=\"test-button\">Test Connection</button>\r\n\r\n<ul id=\"response-list\"></ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/test-connection/test-connection.component.html
// module id = 573
// module chunks = 0